<template>
<Form :label-width="80" class="mt15 w1000">
	<div class="title" style="border-bottom: none;">
		投保单：请先下载投保单，盖上公司公章后再回传投保单。<a @click="download" target="_blank">下载投保单</a>
	</div>
    <FormItem label="">
    	<Form class="policy" :model="form" ref="form" :label-width="0">
    		<Form-item 
    			class="policy-item" 
    			v-for="(p,i) in form.fileList"
    			:prop="'fileList.' + i + '.fileUrl'"
    			:key="i"
    			:rules="{required:true,message:'请上传投保单',trigger:'change'}">
    			<UploadImg 
    				v-model="p.fileUrl" 
    				@on-remove="removeImg(i)"
					@on-success="val=>{uploaded(val, i)}"
    				:show-del="form.fileList.length>1" />
    			<Input v-model="p.fileUrl" v-show="false"></Input>
    		</Form-item>
    		<div class="policy-item" v-if="multiple&&form.fileList.length<10">
    			<a @click="add">添加投保单</a>
    		</div>
    	</Form>
    </FormItem>
</Form>
</template>
<script>
import UploadImg from '../common/UploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				fileList:this.info.fileList && this.info.fileList.length>0?this.info.fileList:[{
					fileUrl:''
				}]
			}
		}
	},
	methods:{
		uploaded(file, index){
			let obj = {
				fileUrl:file.url,
				fileName:file.name,
				fileType:'APPLICATION'
			}
			this.$set(this.form.fileList, index, obj)
		},
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.fileList.push({
				fileUrl:''
			})
		},
		removeImg (i) {
			this.form.fileList.splice(i,1);
		},
		// 下载模板
		download() {
			this.$axios.post('/broker/export/exportApplication.json',{
				bizId: this.info.bizId,
				productCode: this.info.productCode,
				applicationId: this.$route.params.id
			}).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '投保单')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	},
	// watch:{
	// 	'info.fileList' (v) {
	// 		this.form.fileList = v;
	// 	}
	// }
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/person/insuranceSlip.vue